/**
 * Basic class of both communication class type "EventManager" and "HookManager"
 */
abstract class AbstractEventHookManager{

    /**
     * Table for all alias types
     *
     * @example
     * {
     *      {'originalType':'aliasType'}
     * }
     */
    protected systemAlias:Object = {};

    /**
     * Convert event or hook type to string with consideration of alias types
     * @param type
     * @returns {string}
     */
    protected typeToString<T>(type:T):string{
        let typeAsString:string = <string><any>type;

        // get system name is type a alias
        typeAsString = this.systemAlias[typeAsString] || typeAsString;

        return typeAsString;
    }

    /**
     * Register a alias event or hook type
     * @param originalType
     * @param aliasType
     */
    public registerAlias<T>(originalType:string, aliasType:T){
        this.systemAlias[<string><any>aliasType] = originalType;
    }

}

export default AbstractEventHookManager;


// WEBPACK FOOTER //
// ./src/app/communication/AbstractEventHookManager.ts